import React, { useState } from "react";
import { CheckSquare, Trash2, X } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";

function ChecklistBlock({ cl, base, setCls, idx }) {
  const [adding, setAdding] = useState(false);
  const [text, setText] = useState("");
  const [title, setTitle] = useState(cl.title);
  const call = async (fn) => { try { const { data } = await fn(); setCls(data.checklists); } catch (e) { toast.error(e?.response?.data?.detail || "Erreur"); } };
  const done = cl.items.filter((i) => i.done).length;
  const pct = cl.items.length ? Math.round((100 * done) / cl.items.length) : 0;
  const add = async () => {
    if (!text.trim()) return;
    await call(() => api.post(`${base}/${cl.id}/items`, { text: text.trim() }));
    setText("");
  };
  return (
    <div data-testid={`trello-checklist-${idx}`}>
      <div className="flex items-center gap-2 mb-2">
        <CheckSquare className="w-5 h-5 text-norea-textMuted" />
        <input value={title} onChange={(e) => setTitle(e.target.value)} onBlur={() => title.trim() && title !== cl.title && call(() => api.patch(`${base}/${cl.id}`, { title: title.trim() }))}
          onKeyDown={(e) => e.key === "Enter" && e.currentTarget.blur()} className="flex-1 font-semibold text-norea-text bg-transparent focus:outline-none focus:bg-white focus:ring-1 focus:ring-norea-primary rounded px-1" data-testid={`trello-checklist-title-${idx}`} />
        <button onClick={() => window.confirm(`Supprimer la checklist « ${cl.title} » ?`) && call(() => api.delete(`${base}/${cl.id}`))} className="btn-secondary text-xs" data-testid={`trello-checklist-delete-${idx}`}>Supprimer</button>
      </div>
      <div className="flex items-center gap-2 mb-2">
        <span className="text-[11px] text-norea-textMuted w-8 tabular-nums" data-testid={`trello-checklist-pct-${idx}`}>{pct}%</span>
        <div className="flex-1 h-2 rounded-full bg-norea-surfaceHover overflow-hidden">
          <div className={`h-full rounded-full transition-[width] duration-300 ${pct === 100 ? "bg-emerald-500" : "bg-norea-primary"}`} style={{ width: `${pct}%` }} />
        </div>
      </div>
      <ul className="space-y-0.5">
        {cl.items.map((it) => (
          <li key={it.id} className="group flex items-center gap-2.5 px-1 py-1 rounded hover:bg-norea-surfaceHover" data-testid={`trello-item-${it.id}`}>
            <input type="checkbox" checked={!!it.done} onChange={() => call(() => api.patch(`${base}/${cl.id}/items/${it.id}`, { done: !it.done }))} className="w-4 h-4 accent-norea-primary cursor-pointer" data-testid={`trello-item-toggle-${it.id}`} />
            <span className={`flex-1 text-sm ${it.done ? "line-through text-norea-textMuted" : "text-norea-text"}`}>{it.text}</span>
            <button onClick={() => call(() => api.delete(`${base}/${cl.id}/items/${it.id}`))} className="opacity-0 group-hover:opacity-100 text-norea-textMuted hover:text-red-600 transition-opacity" data-testid={`trello-item-delete-${it.id}`}><Trash2 className="w-3.5 h-3.5" /></button>
          </li>
        ))}
      </ul>
      {adding ? (
        <div className="mt-2 space-y-2 pl-7">
          <input autoFocus value={text} onChange={(e) => setText(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") add(); if (e.key === "Escape") setAdding(false); }} placeholder="Ajouter une tâche…" className="input-field text-sm" maxLength={300} data-testid={`trello-item-input-${idx}`} />
          <div className="flex items-center gap-2">
            <button onClick={add} className="btn-primary text-xs" data-testid={`trello-item-add-${idx}`}>Ajouter</button>
            <button onClick={() => setAdding(false)} className="text-norea-textMuted hover:text-norea-text"><X className="w-4 h-4" /></button>
          </div>
        </div>
      ) : (
        <button onClick={() => setAdding(true)} className="btn-secondary text-xs mt-2 ml-7" data-testid={`trello-item-open-${idx}`}>Ajouter une tâche</button>
      )}
    </div>
  );
}

export function TicketChecklists({ ticket, basePath, setCls }) {
  const base = `${basePath}/${ticket.id}/checklists`;
  return (
    <div className="space-y-6" data-testid="trello-checklists">
      {(ticket.checklists || []).map((cl, i) => <ChecklistBlock key={cl.id} cl={cl} idx={i} base={base} setCls={setCls} />)}
    </div>
  );
}

export async function createChecklist(basePath, ticketId, title) {
  try {
    const { data } = await api.post(`${basePath}/${ticketId}/checklists`, { title: title || "Checklist" });
    return data.checklists;
  } catch (e) {
    toast.error(e?.response?.data?.detail || "Erreur");
    return null;
  }
}
